var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.979054 10.1611V10.1592H0.977234V10.1611L0.979054 10.1611Z",
    fill: "#F5F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.979054 5.50202V5.50015H0.977234V5.50198L0.979054 5.50202Z",
    fill: "#F5F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.979054 0.842928V0.841064H0.977234V0.842884L0.979054 0.842928Z",
    fill: "#F5F5F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70451 10.1592H14.0227M4.70451 5.50016H14.0227M4.70451 0.841064H14.0227M0.979054 10.1592V10.1611L0.977234 10.1611V10.1592H0.979054ZM0.979054 5.50016V5.50202L0.977234 5.50197V5.50016H0.979054ZM0.979054 0.841064V0.842928L0.977234 0.842884V0.841064H0.979054Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBlack);
export default __webpack_public_path__ + "static/media/menu-black.da78e586abab4b0621cac14404db3d3f.svg";
export { ForwardRef as ReactComponent };